import { create } from 'zustand';
import { IRbdmMeetCompare } from '@services/hooks/meetings/useMeetCompare';

interface RbdmMeetCompareStore {
	meetCompareData: IRbdmMeetCompare | null;
	isLoading: boolean;
	error: Error | null;
	lastUpdated: string | null;
	setMeetCompareData: (data: IRbdmMeetCompare) => void;
	setLoading: (loading: boolean) => void;
	setError: (error: Error | null) => void;
	clearData: () => void;
}

const initialState = {
	meetCompareData: null,
	isLoading: false,
	error: null,
	lastUpdated: null,
};

export const useRbdmMeetCompareStore = create<RbdmMeetCompareStore>((set) => ({
	...initialState,
	setMeetCompareData: (data: IRbdmMeetCompare): void => {
		set(() => ({
			meetCompareData: data,
			isLoading: false,
			error: null,
			lastUpdated: new Date().toISOString(),
		}));
	},
	setLoading: (loading: boolean): void => {
		set(() => ({ isLoading: loading }));
	},
	setError: (error: Error | null): void => {
		set(() => ({
			error,
			isLoading: false,
		}));
	},
	clearData: (): void => {
		set(() => initialState);
	},
}));
